import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { Loading, ModalContainer } from "web/components"
import { BrowserRouter as Router } from "react-router-dom"
import { AppProviders, LibraryProviders } from "web/Providers"
import Imports from "web/components/Imports/Imports"

export default class ImportsController extends Controller {
  static values = {
    types: Array,
    deprecatedTypes: Array,
    backUrl: String,
    showUrl: String,
  }
  initialize() {
    global.React = React
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <Imports
                backUrl={this.backUrlValue}
                showUrl={this.showUrlValue}
                types={this.typesValue}
                deprecatedTypes={this.deprecatedTypesValue}
              />
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
